import { ALERT_TYPE, ShowToastMessage } from '@laramie/ui';
import { CloneObject } from "../../../utils/helpers";
import { TableCustom, Modal } from "../../common"
import { useEntidad } from "../../hooks";
import {TIPS} from "../../../consts/tips";
import React from "react";

const DireccionesRelacionadasGrid = (props) => {
  const [, getRowEntidad] = useEntidad({
    entidades: ['Provincia','Localidad'],
    onLoaded: (entidades, isSuccess, error) => {
      if (!isSuccess) {
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
      }
    },
    memo: {
      key: 'Provincia_Localidad',
      timeout: 0
    }
  });

  const getDescProvincia = (id) => {
    const row = getRowEntidad('Provincia', id);
    return (row) ? row.nombre : '';
  }
  const getDescLocalidad = (id) => {
    const row = getRowEntidad('Localidad', id);
    return (row) ? row.nombre : '';
  }

  const getDomicilioPostal = (direccionRelacionada) => {
    const calle = getDescProvincia(direccionRelacionada.idProvincia) + ', ' +
                  getDescLocalidad(direccionRelacionada.idLocalidad) + ', ' +
                  `${direccionRelacionada.calle} ${direccionRelacionada.altura} ${direccionRelacionada.piso} ${direccionRelacionada.dpto} (CP ${direccionRelacionada.codigoPostal})`;

    return calle;
  }

  const cellS = (props) =>    <div className='action'>
                                <div onClick={ (event) => handleClickSelect(props.value) } className="link">
                                <span className="material-symbols-outlined" title="Seleccionar">west</span>
                                </div>
                              </div>

  const tableColumns = [
      { Header: '', Cell: cellS, id:'select', accessor: 'id', width: '5%', disableGlobalFilter: true, disableSortBy: true },
      { Header: 'Tipo de vínculo', accessor: 'tipoVinculo', width: '20%' },
      { Header: 'Persona', accessor: 'nombrePersona', width: '25%' },
      { Header: 'Calle', Cell: (props) => getDomicilioPostal(props.row.original), accessor: 'calle', width: '50%' },
    ];

    // handlers
    const handleClickSelect = (id) => {
      const row = props.listDireccionesRelacionadas.find(f => f.id === id);
      props.onConfirm(id, CloneObject(row));
    }

  return (
        <Modal
          size="xl"
          title="Direcciones relacionadas"
          tipName={TIPS.NAME.MODALS.DIRECCIONES_RELACIONADAS_MODAL}
          onEscape={() => props.onDismiss()}
          body={(
                <TableCustom
                  showDownloadCSV={false}
                  showFilterGlobal={false}
                  className={'TableCustomBase'}
                  columns={tableColumns}
                  data={props.listDireccionesRelacionadas}
                  onClickRow={({ original }) => props.onConfirm(original.id, CloneObject(original))}
                />
          )}
          footerClassName="f-align"
          footer={(
                <button className="btn back-button" data-dismiss="modal" onClick={(event) => props.onDismiss()}>Volver</button>
          )}
        />
  )
}

export default DireccionesRelacionadasGrid